<template>
    <div>
        <div class="footerContent">
            <div class="followUs">
                <div class="footerTitle">{{ $t("footer.one08") }}</div>
                <div class="qrcodeBox">
                    <div class="qrcodeItem">
                        <div>
                            <img src="https://bosumjs.oss-accelerate.aliyuncs.com/website/official-accounts.jpg">
                        </div>
                        <p>
                            {{ $t("footer.one02") }}<br>
                        </p>
                    </div>
                    <div class="qrcodeItem qrcodeCenter">
                        <div>
                            <img src="https://bosumjs.oss-accelerate.aliyuncs.com/website/bosumApp.png">
                        </div>
                        <p>
                            {{ $t("footer.one03") }}
                        </p>
                    </div>
                    <div class="qrcodeItem">
                        <div>
                            <img src="https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/wheatSchool/wheatSchoolApp.jpg">
                        </div>
                        <p>
                            {{ $t("footer.one04") }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="footerRight">
                <div>
                    <div class="footerTitle"> {{ $t("footer.one9") }}</div>
                    <ul class="navigation">
                        <li @click="goToPage('/')"> {{ $t("footer.one10") }}</li>
                        <li @click="goToPage('/about')"> {{ $t("footer.one11") }}</li>
                        <li @click="goToPage('/course')"> {{ $t("footer.one12") }}</li>
                    </ul>
                </div>
                <div class="joinSty">
                    <div class="footerTitle" @click="goToPage('/join')"> {{ $t("footer.one13") }}</div>
                    <ul class="navigation">
                        <!-- <li @click="goToPage('/join', 'teacherCoop')"> {{ $t("footer.one14") }}</li>
                        <li @click="goToPage('/join', 'teacherCoop')"> {{ $t("footer.one15") }}</li> -->
                        <a :href="`${RECRUIT_PATH}/#/WCampusIntroduce`" target="_blank" rel="noopener noreferrer">
                           {{ $t('recruit.recruitText1') }}
                        </a>

                        <a :href="`${RECRUIT_PATH}/#/WSocialIntroduce`" target="_blank" rel="noopener noreferrer">
                           {{ $t('recruit.recruitText2') }}
                        </a>

                        <a :href="`${RECRUIT_PATH}/#/WTeacherRecruitment`" target="_blank" rel="noopener noreferrer">
                           {{ $t('recruit.recruitText3') }}
                        </a>
                    </ul>
                </div>
            </div>
        </div>
        <!--备案信息-->
        <div class="xd-record fnt_16 copyright ft_12">
            <a href="http://beian.miit.gov.cn" target="_blank">{{ $t("footer.one05") }}</a>
            <span>@{{ $t("footer.one07") }}</span>
        </div>
    </div>
</template>

<script>
// import '@/assets/styles/pages/footer.scss'
import Common from '@/js/common.js'
const RECRUIT_PATH= process.env.RECRUIT_PATH
export default {
    name: 'mainFooter',
    data: function () {
        return {
            currentYear: new Date().getFullYear(),
            RECRUIT_PATH:RECRUIT_PATH
        }
    },
    mounted: function () {
        var vm = this;
        Common.Utils.showMobileElem();
    },
    methods: {
        goToPage: function (name, commentId) {
            var vm = this;
            vm.$router.push(name);
            this.$store.commit('SET_COMMENT_ID', commentId);
        },
    }
}
</script>

<style lang="scss" scoped>
.footerContent {
    width: 100%;
    height: 290px;
    background: #3F3F3F;
    display: flex;
    align-items: center;
    justify-content: center;

    .footerTitle {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #FFFFFF;
        height: 35px;
        line-height: 25px;
        border-bottom: 1px solid rgba(238, 238, 238, 0.1);

        margin-bottom: 18px;
    }

    .followUs {
        min-width: 350px;
        margin-right: 180px;


        .qrcodeBox {
            width: 100%;
            display: flex;

        }

        .qrcodeCenter {
            margin: 0 34px;
        }

        .qrcodeItem {
            width: 96px;
            height: 120px;
            text-align: center;

            p {
                line-height: 16px;
                font-size: 12px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #999999;
                margin-top: 4px;
                // padding: 0 10px;
            }
        }
    }

    .footerRight {
        min-width: 350px;

        // height: 171px;
        .footerTitle {
            margin-bottom: 9px;
        }

        .navigation {
            display: flex;
            font-size: 12px;

            li {
                color: #999999;
                cursor: pointer;

                &:nth-child(2) {
                    margin: 0 60px;
                }

                &:hover {
                    color: #FFFFFF;
                }
            }
            a {
                font-weight:normal;
                color: #999999;
                cursor: pointer;

                &:nth-child(2) {
                    margin: 0 60px;
                }

                &:hover {
                    color: #FFFFFF;
                }
            }
        }

        .joinSty {
            margin-top: 42px;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue